import { useState } from "react";
import api, { API } from "@/lib/api";
import { toast } from "sonner";
import { Download, Send, ShieldCheck } from "lucide-react";

export default function Alloggiati() {
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [loading, setLoading] = useState(false);

  const onDownload = async () => {
    if (!from || !to) { toast.error("Seleziona un intervallo"); return; }
    setLoading(true);
    try {
      const res = await fetch(`${API}/alloggiati/export?date_from=${from}&date_to=${to}`, {
        credentials: "include",
      });
      if (!res.ok) throw new Error("Errore download");
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url; a.download = `alloggiati_${from}_${to}.txt`;
      a.click(); URL.revokeObjectURL(url);
      toast.success("File scaricato");
    } catch (err) { toast.error(err.message); }
    finally { setLoading(false); }
  };

  const onSend = async () => {
    if (!from || !to) { toast.error("Seleziona un intervallo"); return; }
    setLoading(true);
    try {
      const { data } = await api.post(`/alloggiati/send?date_from=${from}&date_to=${to}`);
      toast.success(data.message);
    } catch (err) { toast.error(err?.response?.data?.detail || "Errore"); }
    finally { setLoading(false); }
  };

  return (
    <div className="p-6 md:p-12 max-w-4xl">
      <p className="text-xs tracked text-blue-700 mb-2">CONFORMITÀ</p>
      <h1 className="font-heading font-semibold text-4xl tracking-tight mb-2">Alloggiati Web — Polizia di Stato</h1>
      <p className="text-slate-600 mb-8">Genera ed invia (mock) le schedine al portale ufficiale entro le 24 ore.</p>

      <div className="border border-slate-200 bg-white p-8">
        <div className="grid md:grid-cols-2 gap-4 mb-6">
          <label className="block">
            <span className="text-xs text-slate-500">DAL</span>
            <input data-testid="alloggiati-from" type="date" value={from} onChange={(e) => setFrom(e.target.value)}
              className="w-full mt-1 border border-slate-300 px-3 py-2 text-sm focus:outline-none focus:border-blue-700 bg-white" />
          </label>
          <label className="block">
            <span className="text-xs text-slate-500">AL</span>
            <input data-testid="alloggiati-to" type="date" value={to} onChange={(e) => setTo(e.target.value)}
              className="w-full mt-1 border border-slate-300 px-3 py-2 text-sm focus:outline-none focus:border-blue-700 bg-white" />
          </label>
        </div>
        <div className="flex flex-wrap gap-3">
          <button data-testid="alloggiati-download" onClick={onDownload} disabled={loading}
            className="inline-flex items-center gap-2 bg-stone-900 text-stone-50 px-5 py-2.5 text-sm rounded-lg hover:bg-stone-800 disabled:opacity-60">
            <Download className="w-4 h-4" /> Scarica .txt ufficiale
          </button>
          <button data-testid="alloggiati-send" onClick={onSend} disabled={loading}
            className="inline-flex items-center gap-2 bg-blue-700 text-stone-50 px-5 py-2.5 text-sm rounded-lg hover:bg-blue-700 disabled:opacity-60">
            <Send className="w-4 h-4" /> Invia al portale (mock)
          </button>
        </div>
      </div>

      <div className="mt-8 border border-slate-200 bg-slate-50 p-6 flex gap-4">
        <ShieldCheck className="w-6 h-6 text-blue-700 flex-shrink-0" strokeWidth={1.5} />
        <div className="text-sm text-slate-700">
          <strong className="font-medium">Come funziona</strong>: il file generato segue il formato a lunghezza fissa richiesto dal portale Alloggiati Web.
          La modalità "Invia al portale" è attualmente <em>simulata</em>: consigliamo di scaricare il file e caricarlo manualmente nel portale,
          autenticandoti col tuo certificato digitale.
        </div>
      </div>
    </div>
  );
}
